import React, { useState, useEffect } from 'react';
import TopNavigation from '@cloudscape-design/components/top-navigation';
import AppLayout from '@cloudscape-design/components/app-layout';
import SideNavigation from '@cloudscape-design/components/side-navigation';
import { applyMode, Mode } from '@cloudscape-design/global-styles';
import { signOut } from '../api/auth';

interface ServiceLayoutProps {
  children: React.ReactNode;
}

function getInitialTheme(): boolean {
  const stored = localStorage.getItem('eventstore-theme');
  if (stored) return stored === 'dark';
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function ServiceLayout({ children }: ServiceLayoutProps) {
  const [darkMode, setDarkMode] = useState(getInitialTheme);

  useEffect(() => {
    applyMode(darkMode ? Mode.Dark : Mode.Light);
    localStorage.setItem('eventstore-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  return (
    <>
      <div id="top-nav">
        <TopNavigation
          identity={{
            href: '/',
            title: 'EventStore',
          }}
          utilities={[
            {
              type: 'menu-dropdown',
              text: 'us-east-2',
              items: [{ id: 'us-east-2', text: 'US East (Ohio)' }],
            },
            {
              type: 'menu-dropdown',
              text: 'Settings',
              items: [
                { id: 'theme', text: darkMode ? '☀ Light mode' : '🌙 Dark mode' },
                { id: 'sign-out', text: 'Sign out' },
              ],
              onItemClick: ({ detail }) => {
                if (detail.id === 'theme') setDarkMode(!darkMode);
                if (detail.id === 'sign-out') signOut();
              },
            },
          ]}
          i18nStrings={{ overflowMenuTriggerText: 'More' }}
        />
      </div>
      <AppLayout
        content={children}
        navigationHide={false}
        navigation={
          <SideNavigation
            items={[
              { type: 'link', text: 'Stores', href: '/stores' },
              { type: 'link', text: 'Views', href: '/views' },
              { type: 'link', text: 'Explorer', href: '/explorer' },
              { type: 'link', text: 'Documentation', href: 'https://docs.aws.amazon.com/eventstore', external: true },
            ]}
          />
        }
        toolsHide={true}
        headerSelector="#top-nav"
      />
    </>
  );
}
